/**
 * SocialNetworksWidget — widget de painel de controle para gerenciar
 * as redes sociais do site ODC.
 *
 * Usa o ObjectListWidget do Volto com um schema estático de duas colunas:
 * rede social (Choice) e URL.
 */
import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  socialNetwork: {
    id: 'social.widget.network',
    defaultMessage: 'Social Network',
  },
  socialNetworkUrl: {
    id: 'social.widget.url',
    defaultMessage: 'Social Network URL',
  },
  socialNetworkUrlHelp: {
    id: 'social.widget.urlHelp',
    defaultMessage:
      'Full URL of the social network profile. E.g.: https://www.network.com/profilename',
  },
  refreshPage: {
    id: 'social.widget.refresh',
    defaultMessage: 'Refresh the page to see your changes',
  },
});

export const ALL_SOCIAL_CHOICES: [string, string][] = [
  ['Facebook', 'Facebook'],
  ['Instagram', 'Instagram'],
  ['Youtube', 'Youtube'],
  ['Linkedin', 'Linkedin'],
  ['Whatsapp', 'Whatsapp'],
  ['X', 'X'],
  ['TikTok', 'TikTok'],
  ['Threads', 'Threads'],
  ['Flickr', 'Flickr'],
  ['Tumblr', 'Tumblr'],
  ['RSS', 'RSS'],
  ['Bluesky', 'Bluesky'],
  ['Soundcloud', 'Soundcloud'],
  ['Slideshare', 'Slideshare'],
  ['Kwai', 'Kwai'],
];

const buildItemSchema = (intl: ReturnType<typeof useIntl>) => ({
  title: intl.formatMessage(messages.socialNetwork),
  properties: {
    social_network: {
      title: intl.formatMessage(messages.socialNetwork),
      type: 'string',
      factory: 'Choice',
      choices: ALL_SOCIAL_CHOICES,
      noValueOption: false,
    },
    social_network_url: {
      title: intl.formatMessage(messages.socialNetworkUrl),
      description: intl.formatMessage(messages.socialNetworkUrlHelp),
      type: 'string',
      format: 'url',
    },
  },
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.socialNetwork),
      fields: ['social_network', 'social_network_url'],
    },
  ],
  required: ['social_network', 'social_network_url'],
});

const SocialNetworksWidget = (props: any) => {
  const intl = useIntl();
  const items = props.value?.items ?? props.default?.items ?? [];
  const schema = buildItemSchema(intl);

  return (
    <>
      <ObjectListWidget
        {...props}
        schema={schema}
        value={items}
        onChange={(id: string, value: any[]) =>
          props.onChange(id, { items: value })
        }
      />
      <p className="help" style={{ textAlign: 'center', padding: 8 }}>
        {intl.formatMessage(messages.refreshPage)}
      </p>
    </>
  );
};

export default SocialNetworksWidget;
